<template>
  <GChart
    :settings="{ packages: ['orgchart'] }"
    type="OrgChart"
    :data="chartData"
    @ready="drawCharts"
  />
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
    name: 'DiscipleshipTree',
    components: {
        GChart,

    },
    data() {
        return {
            chartData: null,
        };
    },
    props: {
        disciples: null,
    },
    watch: {
      	disciples(newVal, oldVal) { // watch it
            this.drawCharts();
        }
    },
    methods: {
        drawCharts() {
            // console.log('disciples');
            // console.log(this.disciples); // For testing
            this.disciples.forEach((item) => this.drawChart(item));
        },
        drawChart(item) {
            // console.log(item.id);
            this.chartData = new google.visualization.DataTable();
            this.chartData.addColumn('string', 'Name');
            this.chartData.addColumn('string', 'Manager');
            this.chartData.addColumn('string', 'ToolTip');
            // For each orgchart box, provide the name, manager, and tooltip to show.
            this.chartData.addRows(item.data);

            // Create the chart.
            const chart = new google.visualization.OrgChart(document.getElementById(item.id));

            const dataForListener = [chart, this.chartData];

            // selection
            google.visualization.events.addListener(dataForListener[0], 'select', () => {
                const selection = dataForListener[0].getSelection()[0];

                if (selection) {
                    const selectedValue = dataForListener[1].getValue(selection.row, 0);
                    // console.log(`The user selected the person with the id of ${selectedValue}`);
                    if (selectedValue > 0) {
                        this.$router.push(`/people/${selectedValue}`);
                    }
                }
                // clear the selection so the next click will work properly
                dataForListener[0].setSelection();
            });

            // Draw the chart, setting the allowHtml option to true for the tooltips.
            chart.draw(this.chartData, {
                allowHtml: true, nodeClass: 'nodes', size: 'medium', selectedNodeClass: 'selected'
            });

            document.getElementById(item.id).style.display = 'block';
        }
    },

};
</script>

<style scoped>

table {
      border-collapse: inherit;
      border-spacing: 0;

}

#tree {
  padding: 20px;
  overflow: auto;
}

.nodes {
    text-align: center;
    vertical-align: middle;
    font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
    cursor: default;
    border-radius: 4px;
    font-size: 14px !important;
    color: white;
    background: #6cc070
}

.selected {
    text-align: center;
    vertical-align: middle;
    font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
    cursor: default;
    border-radius: 4px;
    font-size: 14px !important;
    color: white;
    background: #5061c2
}
</style>
